<ng-template #content>
    <div
        *ngIf="!message.deleted"
        (click)="onDeleteChatMessage(message.messageId, false)"
        class="chat-message__action chat-message__action--border chat-message__action--red d-flex align-items-center cursor-pointer px-2"
    >
        <app-icon-bin color="#FE5353" class="btn--bin cursor-pointer mr-2"></app-icon-bin>
        <div>Delete Message</div>
    </div>
    <ng-container *ngIf="message.messageStatus !== 2" >
        <div
            *ngIf="message.blocked === false"
            (click)="onDeleteChatMessage(message.messageId, true)"
            class="chat-message__action chat-message__action--red d-flex align-items-center cursor-pointer px-2"
        >
            <app-icon-block color="#FE5353" class="btn--bin cursor-pointer mr-2"></app-icon-block>
            <div>Block User</div>
        </div>
        <div
            *ngIf="message.blocked === true"
            (click)="onUnblockChatAttendee(message.messageId)"
            class="chat-message__action chat-message__action--green d-flex align-items-center cursor-pointer px-2"
        >
            <app-icon-block color="#00c851" class="btn--bin cursor-pointer mr-2"></app-icon-block>
            <div>Unblock User</div>
        </div>
    </ng-container>
</ng-template>
<ng-container *ngIf="user$ | async as user">
    <div class="chat-message" [ngClass]="classes">
        <div class="chat-message__body d-flex align-items-end" [ngStyle]="styles">
            <div class="chat-message__avatar mr-2">
                <img [src]="message.donor.image" height="32" width="32" />
            </div>
            <div class="chat-message__bubble w-100">
                <div class="d-flex justify-content-between">
                    <div class="chat-message__name" [ngStyle]="{'color': getUserColor(user)}">{{getName(user)}}</div>
                    <button
                        *ngIf="showActions()"
                        type="button"
                        placement="left"
                        class="btn  btn--paybee mdb-popover"
                        [mdbPopover]="content"
                        (popoverShown)="onPopoverShown()"
                        (popoverHidden)="onPopoverHidden()"
                        trigger="click"
                        #popover="mdbPopover"
                     >
                     <svg class="chat__icon cursor-pointer" width="16px" height="4px" viewBox="0 0 24 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <title>Shape</title>
                        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Icons-/-more" transform="translate(-3.000000, -12.000000)">
                                <g transform="translate(3.000000, 12.000000)">
                                    <path d="M12,6 C10.3431458,6 9,4.65685425 9,3 C9,1.34314575 10.3431458,0 12,0 C13.6568542,0 15,1.34314575 15,3 C15,4.65685425 13.6568542,6 12,6 Z M21,6 C19.3431458,6 18,4.65685425 18,3 C18,1.34314575 19.3431458,0 21,0 C22.6568542,0 24,1.34314575 24,3 C24,4.65685425 22.6568542,6 21,6 Z M3,6 C1.34314575,6 0,4.65685425 0,3 C0,1.34314575 1.34314575,0 3,0 C4.65685425,0 6,1.34314575 6,3 C6,4.65685425 4.65685425,6 3,6 Z" id="Shape" fill-rule="nonzero"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                    </button>
                </div>
                <div class="chat-message__text">{{message.message}}</div>
            </div>
        </div>
        <div class="chat-message__footer mt-1">
            <div class="d-flex justify-content-between px-1">
                <div class="chat-message__time">{{timer$ | async | messageTimer }}</div>
                <div class="chat-message__description chat-message__description--red">{{getMessageDescription()}}</div>
            </div>
        </div>
    </div>
</ng-container>
